import { ArrowDownRight } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/da1e7d73-0d05-4f2a-8362-e5220f03b9da/images/7ced237faeec2ec50b36013aebd905fd7c2df93faa163020a435d737c501a82b.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full flex items-end overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/55 to-[#050505]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-32 md:py-40 w-full">
        <div className="flex items-center gap-3 mb-10 reveal-up">
          <span className="block w-10 h-px bg-[#C2A878]" />
          <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
            Bay of Plenty · Aotearoa
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="font-serif font-light text-5xl sm:text-6xl md:text-5xl lg:text-[7.5rem] leading-[0.95] tracking-tight text-white max-w-5xl reveal-up"
          style={{ animationDelay: "120ms" }}
        >
          Revenue, occupancy <em className="text-[#C2A878] not-italic">and</em>
          <br />
          operational sanity.
          <br />
          <span className="italic font-light text-white/85">Built</span> for accommodation providers.
        </h1>

        <div
          data-testid="hero-subhead"
          className="mt-10 max-w-2xl reveal-up"
          style={{ animationDelay: "240ms" }}
        >
          <p className="text-base md:text-lg text-white/70 leading-relaxed">
            Black Rock Hospitality is a dedicated agency designed to support
            accommodation providers through tailored consultancy services and
            management solutions.
            <br />
            <br />
            We partner with property managers, motels, and hotels to streamline
            operations, improve efficiency, and deliver exceptional guest
            experiences; while also offering management solutions for Airbnb
            operators and short-term rental properties.
            <br />
            <br />
            We help operators:
          </p>
          <ul className="mt-6 space-y-2.5 text-base md:text-lg text-white/80">
            {[
              "Increase occupancy",
              "Grow revenue",
              "Implement standard operating procedures",
              "Elevate guest satisfaction",
              "And much, much more",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <span className="block w-1.5 h-1.5 rounded-full bg-[#C2A878] flex-shrink-0" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="mt-12 reveal-up"
          style={{ animationDelay: "360ms" }}
        >
          <p className="text-base md:text-lg text-white/85 italic font-serif mb-5">
            Let&apos;s see how you could be performing better, today.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a
              href="#audit"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-3 bg-[#C2A878] hover:bg-[#D4AF37] text-[#050505] px-7 py-4 text-xs font-semibold tracking-[0.2em] uppercase transition-all duration-300"
            >
              Book a mini audit
              <ArrowDownRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-3 border border-white/20 hover:border-[#C2A878] hover:text-[#C2A878] text-white px-7 py-4 text-xs font-semibold tracking-[0.2em] uppercase transition-all duration-300"
            >
              How we work
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="pointer-events-none absolute bottom-6 right-6 hidden md:flex items-center gap-3 text-white/40 text-[10px] tracking-[0.3em] uppercase">
        Scroll
        <span className="block w-px h-10 bg-white/30" />
      </div>
    </section>
  );
}
